<template>
  <div class="d-inline">
    <!-- Button to open the modal -->
    <b-button @click="$bvModal.show('bv-modal-pull-data')" v-b-tooltip.hover.top="'Sync device data to update employee attendance.'">
      Pull Device Data
    </b-button>

    <!-- Date range modal -->
    <b-modal id="bv-modal-pull-data" title="Select Date Range" hide-footer>

        <b-form-group id="from_date-group" label="From Date" label-for="from_date" class="required-field mb-0">
          <b-input-group class="mb-0">
            <b-form-input  id="from_date" name="from_date" v-model="fdata.from_date"
                          v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :state="validateState('from_date')" aria-describedby="from_date-feedback" data-vv-as="From Date"/>
            <b-input-group-append class="mb-0">
              <b-form-datepicker :max="new Date()" @input="fdata.to_date = fdata.from_date" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.from_date" />
            </b-input-group-append>
            <b-form-invalid-feedback id="from_date-feedback">
              {{ veeErrors.first('from_date') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>

        <b-form-group id="to_date-group" label="To Date" label-for="to_date" class="required-field mb-0">
          <b-input-group class="mb-0">
            <b-form-input  id="to_date" name="to_date" v-model="fdata.to_date"
                          v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :state="validateState('to_date')" aria-describedby="to_date-feedback" data-vv-as="To Date"/>
            <b-input-group-append class="mb-0">
              <b-form-datepicker :max="new Date()" :min="fdata.from_date" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.to_date" />
            </b-input-group-append>
            <b-form-invalid-feedback id="to_date-feedback">
              {{ veeErrors.first('to_date') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>

        <div class="text-center mt-4">
          <b-button variant="secondary" @click="$bvModal.hide('bv-modal-pull-data')">Cancel</b-button>
          <b-button variant="primary" type="button" @click="pullData">Pull Data</b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fdata : {
        from_date: new Date().toISOString().slice(0, 10),
        to_date: new Date().toISOString().slice(0, 10),
      },
    }
  },
  methods: {
    toYMD (d) {
      const dd = d instanceof Date ? d : new Date(d)
      const y = dd.getFullYear()
      const m = String(dd.getMonth() + 1).padStart(2, '0')
      const day = String(dd.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    resetForm(){
      this.fdata = {
        from_date: '',
        to_date: '',
      };
    },
    pullData () {
      const formData = new FormData()
      formData.append('from_date', this.toYMD(this.fdata.from_date))
      formData.append('to_date', this.toYMD(this.fdata.to_date))

      this.$emit('startLoading')
      this.$bvModal.hide('bv-modal-pull-data')

      axios.post(this.$api_url + '/leave-attendance/data/pull', formData).then((response) => {
        this.resetForm();
        this.$emit('childToParent', 0, 'Attendance Data Synced Successfully')
        this.$emit('stopLoading')
        this.$emit('success')
      }).catch(e => {
        this.serverError(e)
        this.$emit('stopLoading')
      })
    }
  }
}
</script>
